import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
  import type { PropType } from 'vue'
  import Checkout from '@/components/checkout/Checkout.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  import { CourseModule } from '@/store/modules/course'
  import useCourse from '@/composables/useCourse'
  import { useRoute, useRouter } from 'vue-router/composables'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutModal',
  props: {
    user: {
      type: Object as PropType<{ id: string; name: string; email: string }>,
      required: true,
    },
    isPackageCheckout: {
      type: Boolean,
      default: false,
    },
    showPreviousCTA: {
      type: Boolean,
      default: true,
    },
    inModuleOrLessonView: {
      type: Boolean,
      default: false,
    },
    showCustomCheckoutTitle: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props;

  

  const route = useRoute()
  const router = useRouter()
  const checkoutDone = ref(false)
  const checkoutCancel = ref(false)
  const { openAssignCoursesModal } = useCommonMixin()
  const { course } = useCourse()
  const { translateString } = useI18n()
  const showPackageCTA = ref(false)

  const routeToPackageCheckout = () => {
    eventBus.$emit('close-modal')
    router
      .push({
        name: 'PackageCheckout',
        params: { packageId: course.value!.courseBundle!.courseBundleId },
      })
      .catch(() => {
        return
      })
  }

  watch(checkoutDone, (value: boolean) => {
    if (value) {
      eventBus.$emit('update-modal-title', translateString('homepage.assignedCourses.successfullyBought'))
      if (props.inModuleOrLessonView) {
        window.location.reload()
      } else {
        CourseModule.getMemberCourses({ auth0Id: props.user.id })
      }
    }
  })

  onMounted(() => {
    if (route.query.status) {
      const status = (route.query.status as string)?.split('?')[0]
      if (status === 'success') {
        checkoutDone.value = true
      } else if (status === 'cancel') {
        checkoutCancel.value = true
      }
      router.replace({ query: {} })
    }
  })

  onBeforeUnmount(() => {
    if (!props.inModuleOrLessonView) {
      CourseModule.setCourseBundle(null)
      CourseModule.setCourse(null)
    }
  })

return { __sfc: true,props, route, router, checkoutDone, checkoutCancel, openAssignCoursesModal, course, translateString, showPackageCTA, routeToPackageCheckout, onBeforeUnmount, onMounted, ref, watch, Checkout, KetchUpButton, useCommonMixin, CourseModule, useCourse, useRoute, useRouter, eventBus, useI18n }
}

})